import pt from "./pt";
import fr from "./fr";
import sp from "./sp";
import en from "./en";

export default class I18n{

    static exec(){
        let currentLanguage = I18n.lang();
        document.querySelectorAll<HTMLSpanElement>(".i18n")
        .forEach((i18nEntrie:HTMLSpanElement)=>{
            let valueToStranslate = i18nEntrie.dataset.value;
            i18nEntrie.textContent = I18n.loadTranslate(currentLanguage,valueToStranslate);
        });
    }

    static lang():string{
        return localStorage.getItem("i18n") || "pt";
    }

    static apply(textValue:string,...classList):string{
        return `<span class="i18n ${classList?.join(" ")??""}" data-value="${textValue.trim()}">${textValue}</span>`;
    }

    static translate(value:string):string{
        let currentLanguage = I18n.lang();
        return I18n.loadTranslate(currentLanguage,value);
    }

    private static loadTranslate(lang:string,value:string):string{
        if(lang=="pt") return pt[value];
        if(lang=="fr") return fr[value];
        if(lang=="sp") return sp[value];
        if(lang=="en") return en[value];
    }
}